import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { UserService } from "../../services/user.service";
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-login',
  templateUrl: '../../templates/login/login.component.html'
})

export class LoginComponent {

  email : string;
  password : string;
  user: firebase.User;
  error:any;
  constructor(public userService: UserService, public router: Router) {
    this.user = this.userService.getCurrentUser();
    if (this.user && this.user !== null) {
      this.router.navigate(['/dashboard'])
    }
  }

  login(formData) {
    if(formData.valid) {
      this.userService.login(formData.value.email,formData.value.password);
    }
  }

  logout() {
      this.userService.logout();
  }

}


// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/login/login.component.ts